<template>
  <div class="TrainingRescedule">
    <SOSlotBase :container-name="`trainingPilihJadwal`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Pilih Jadwal'" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <div class="bg-grey p-x-20 p-y-12 d-flex">
          <div class="d-block">
            <p class="f-Overpass f-14 f-c-midgrey f-bold remove-margin">
              Pilih tanggal yang tertera dibawah untuk menentukan jadwal
              training
            </p>
          </div>
        </div>

        <CalendarRescedule
          :Jadwal_Full="dataDateDisable != null ? dataDateDisable : ''"
          :Jadwal_Exist="dataTimeExist"
          :id_jenis="paramIdJenis"
        />

        <div class="p-x-20 main-page-tab">
          <button
            class="btn btn-primary btn-long"
            :disabled="checkDisable()"
            @click="checkValidationRescedule"
          >
            Lanjutkan
          </button>
        </div>
      </template>
      <template v-slot:modal>
        <ModalConfirmRescedule ref="confirmModal" :idjenis="paramIdJenis" />
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
// import Calendar from "../components/Calendar";
import CalendarRescedule from "../components/CalendarRescedule.vue";
import ModalConfirmRescedule from "../components/ModalConfirmRescedule.vue";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "TrainingRescedule",
  components: {
    SOSlotBase,
    SOTitleBar,
    CalendarRescedule,
    ModalConfirmRescedule,
    // Calendar,
  },

  data() {
    return {
      idJenis: "",
      isLoading: false,
      paramIdJenis: this.$route.params.idjenis,
      tanggal_mulai: "2023-09-01",
      dataDateDisable: [],
    };
  },
  //
  async mounted() {
    await this.getJadwal();
    await this.getJadwalDisable();
  },

  computed: {
    ...mapGetters(moduleName, {
      dataRescedule: "dataRescedule",
      dataTimeExist: "dataTimeExist",
      dataJadwalUnavailable: "dataJadwalUnavailable",
    }),
  },

  methods: {
    ...mapActions({
      getDetailJenisTraining: `${moduleName}/getDetailJenisTraining`,
      getDataJadwalDisable: `${moduleName}/getDataJadwalDisable`,
    }),

    back() {
      this.resetState();
      this.$router.go(-1);
    },

    resetState() {
      this.dataRescedule.id_detail_training = "";
      this.dataRescedule.jadwal_mulai = "";
      this.dataRescedule.jadwal_selesai = "";
      this.dataRescedule.jadwal_ke = "";
      this.dataRescedule.jadwal_change = "";
      this.dataRescedule.jadwal_range = "";
    },

    checkDisable() {
      if (this.dataRescedule.jadwal_mulai == "") {
        return true;
      } else {
        return false;
      }
    },

    checkValidationRescedule() {
      this.$refs.confirmModal.open();
    },

    async getJadwal() {
      this.isLoading = true;
      let data = {
        idjenis: this.paramIdJenis,
        tanggal_mulai: this.tanggal_mulai,
        tanggal_selesai: this.$moment(this.tanggal_mulai)
          .add(3, "M")
          .format("YYYY-MM-DD"),
      };
      let res = await this.getDataJadwalDisable(data);

      if (res) {
        this.isLoading = false;
      }
    },

    getJadwalDisable() {
      for (let i = 0; i < this.dataJadwalUnavailable.length; i++) {
        let formatDate = this.$moment(
          this.dataJadwalUnavailable[i].tanggal
        ).format("YYYY-MM-DD");
        this.dataDateDisable.push(formatDate);
      }
    },
  },
};
</script>
